import styled from "styled-components";

export const Page = styled.main`
    max-width: 720px;
    margin: 0 auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Card = styled.section`
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
`;

export const Muted = styled.span`
    color: var(--muted);
    font-size: 14px;
`;

export const Button = styled.button<{ $primary?: boolean; $danger?: boolean }>`
    font: inherit;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid ${({ $primary, $danger }) => ($danger ? "var(--bad)" : $primary ? "var(--accent)" : "var(--border)")};
    background: ${({ $primary }) => ($primary ? "var(--accent)" : "var(--surface)")};
    color: ${({ $primary, $danger }) => ($danger ? "var(--bad)" : $primary ? "var(--accent-text)" : "var(--text)")};
    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const Label = styled.label`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    color: var(--muted);
`;

export const Input = styled.input`
    font: inherit;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: var(--background);
    color: var(--text);
`;

export const TextArea = styled(Input).attrs({ as: "textarea" })`
    min-height: 120px;
    resize: vertical;
`;

export const ErrorText = styled.p`
    margin: 0;
    color: var(--bad);
`;
